module.exports = __webpack_public_path__ + "img/international-market-icon.a4f91d56.svg";